import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ToggleFullScreenDirective} from './fullscreen/toggle-fullscreen.directive';
import {AccordionAnchorDirective} from './accordion/accordionanchor.directive';
import {AccordionLinkDirective} from './accordion/accordionlink.directive';
import {AccordionDirective} from './accordion/accordion.directive';
import {HttpClientModule} from '@angular/common/http';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {TitleComponent} from '../layout/admin/title/title.component';
import {CardComponent} from './card/card.component';
import {CardToggleDirective} from './card/card-toggle.directive';
import {ModalBasicComponent} from './modal-basic/modal-basic.component';
import {ModalAnimationComponent} from './modal-animation/modal-animation.component';
import {SpinnerComponent} from './spinner/spinner.component';
import {ClickOutsideModule} from 'ng-click-outside';
import {DataFilterPipe} from './elements/data-filter.pipe';
import {CardTabsComponent} from './card-tabs/card-tabs.component';
import {CustomSelectComponent} from './components/custom-select/custom-select.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {IcofontComponent} from './components/icofont/icofont.component';
import {InputNumericComponent} from './components/input-numeric/input-numeric.component';
import {InputClearComponent} from './components/input-clear/input-clear.component';
import {SpinnerServeComponent} from './spinner-serve/spinner-serve.component';
import {ModalConfirmacionComponent} from './modal-confirmacion/modal-confirmacion.component';
import {PopupVisorPdfComponent} from './popup-visor-pdf/popup-visor-pdf.component';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {ModalRegistrosErroresComponent} from './modal-registros-errores/modal-registros-errores.component';
import {DxDataGridModule} from 'devextreme-angular';
import {ScrollPanelModule} from 'primeng/primeng';
import {ModalResumenCargaArchivosComponent} from './modal-resumen-carga-archivos/modal-resumen-carga-archivos.component';
import {InputMaskModule} from 'primeng/inputmask';
import {ModalErroresGenericoComponent} from './modal-errores-generico/modal-errores-generico.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
   suppressScrollX: true
};

@NgModule({
   imports: [
      CommonModule,
      NgbModule.forRoot(),
      HttpClientModule,
      PerfectScrollbarModule,
      ClickOutsideModule,
      FlexLayoutModule,
      PdfViewerModule,
      DxDataGridModule,
      ScrollPanelModule
   ],
   exports: [
      NgbModule,
      ToggleFullScreenDirective,
      AccordionAnchorDirective,
      AccordionLinkDirective,
      AccordionDirective,
      CardToggleDirective,
      HttpClientModule,
      PerfectScrollbarModule,
      TitleComponent,
      CardComponent,
      ModalBasicComponent,
      ModalAnimationComponent,
      SpinnerComponent,
      ClickOutsideModule,
      DataFilterPipe,
      CardTabsComponent,
      CustomSelectComponent,
      IcofontComponent,
      InputNumericComponent,
      InputClearComponent,
      SpinnerServeComponent,
      InputMaskModule,
   ],
   declarations: [
      ToggleFullScreenDirective,
      AccordionAnchorDirective,
      AccordionLinkDirective,
      AccordionDirective,
      CardToggleDirective,
      TitleComponent,
      CardComponent,
      ModalBasicComponent,
      ModalAnimationComponent,
      SpinnerComponent,
      DataFilterPipe,
      CardTabsComponent,
      CustomSelectComponent,
      IcofontComponent,
      InputNumericComponent,
      InputClearComponent,
      SpinnerServeComponent,
      ModalConfirmacionComponent,
      PopupVisorPdfComponent, ModalRegistrosErroresComponent, ModalResumenCargaArchivosComponent, ModalErroresGenericoComponent,
   ],
   providers: [
      {
         provide: PERFECT_SCROLLBAR_CONFIG,
         useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
      }
   ],
   schemas: [NO_ERRORS_SCHEMA],
   entryComponents: [
      ModalConfirmacionComponent,
      PopupVisorPdfComponent,
      ModalRegistrosErroresComponent,
      ModalResumenCargaArchivosComponent,
      ModalErroresGenericoComponent,
   ]
})
export class SharedModule {
}
